import { ValidationError } from './ValidationError';
export const ChannelNameInputField = ({ name = '', error, placeholder = 'channel-name', onChange }) => {
    return (<div className='channel-name-input-field'>
      <h2><span> Group Name</span><ValidationError errorMessage={error}/></h2>
      <input onChange={onChange} placeholder={placeholder} type='text' value={name}/>
    </div>);
};
